import axios, {AxiosRequestConfig} from 'axios';
import {cookies} from '@/plugins/cookies';

export function helpdeskAxios(config: AxiosRequestConfig) {
  const token = cookies.get('authToken') || '';
  return axios({
    ...config,
    headers: {
      Authorization: `Bearer ${token}`,
      ...config.headers,
    },
  });
}
